module.exports = __webpack_public_path__ + "img/chatDisconnectIcon.25456984.svg";